'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _reactisForms = require('reactis-forms');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Glyphicon = require('./Glyphicon');

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

var _components = {
	_$TextArea: {
		displayName: 'TextArea'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var TextArea = (function (_React$Component) {
	_inherits(TextArea, _React$Component);

	function TextArea() {
		_classCallCheck(this, _TextArea);

		_React$Component.apply(this, arguments);
	}

	TextArea.prototype.getError = function getError() {
		return this.props.error && this.props.error[0];
	};

	TextArea.prototype.renderInputGroup = function renderInputGroup(children) {
		var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonBefore' },
			this.props.addonBefore
		) : null;

		var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonAfter' },
			this.props.addonAfter
		) : null;

		var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonBefore
		) : null;

		var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonAfter
		) : null;

		var inputGroupClassName = undefined;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		return addonBefore || addonAfter || buttonBefore || buttonAfter ? _react2['default'].createElement(
			'div',
			{ className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
			addonBefore,
			buttonBefore,
			children,
			addonAfter,
			buttonAfter
		) : children;
	};

	TextArea.prototype.renderIcon = function renderIcon() {
		if (this.props.hasFeedback) {
			if (this.props.feedbackIcon) {
				return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
			}

			switch (this.props.bsStyle) {
				case 'success':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
				case 'warning':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
				case 'error':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
				default:
					return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
			}
		} else {
			return null;
		}
	};

	TextArea.prototype.renderHelp = function renderHelp() {
		return this.props.help ? _react2['default'].createElement(
			'span',
			{ className: 'help-block', key: 'help' },
			this.props.help
		) : null;
	};

	TextArea.prototype.renderWrapper = function renderWrapper(children) {

		var classes = {
			'has-error': this.getError()
		};

		return _react2['default'].createElement(
			'span',
			{ className: _classnames2['default'](classes, this.props.wrapperClassName), key: 'wrapper' },
			children
		);
	};

	TextArea.prototype.renderLabel = function renderLabel(children) {
		var classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? _react2['default'].createElement(
			'label',
			{ htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
			children,
			this.props.label
		) : children;
	};

	TextArea.prototype.renderInput = function renderInput() {

		var className = 'form-control';
		return _react2['default'].createElement(_reactisForms.TextArea, _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), key: 'input' }));
	};

	TextArea.prototype.renderError = function renderError() {
		var error = this.getError();
		return error ? _react2['default'].createElement(
			'span',
			{ className: 'error-block', key: 'error' },
			error
		) : null;
	};

	TextArea.prototype.renderChildren = function renderChildren() {
		return [
		//this.renderLabel(),
		this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderError()])];
	};

	TextArea.prototype.render = function render() {
		var children = this.renderChildren();
		return _react2['default'].createElement(
			'span',
			null,
			children
		);
	};

	var _TextArea = TextArea;
	TextArea = _wrapComponent('_$TextArea')(TextArea) || TextArea;
	return TextArea;
})(_react2['default'].Component);

TextArea.propTypes = {
	type: _react2['default'].PropTypes.string,
	label: _react2['default'].PropTypes.node,
	help: _react2['default'].PropTypes.node,
	addonBefore: _react2['default'].PropTypes.node,
	addonAfter: _react2['default'].PropTypes.node,
	buttonBefore: _react2['default'].PropTypes.node,
	buttonAfter: _react2['default'].PropTypes.node,
	bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: _react2['default'].PropTypes.bool,
	feedbackIcon: _react2['default'].PropTypes.node,
	id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	groupClassName: _react2['default'].PropTypes.string,
	wrapperClassName: _react2['default'].PropTypes.string,
	labelClassName: _react2['default'].PropTypes.string,
	disabled: _react2['default'].PropTypes.bool,
	value: _react2['default'].PropTypes.any
};

TextArea.defaultProps = {
	type: 'text',
	disabled: false,
	hasFeedback: false
};

exports['default'] = TextArea;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/TextArea.js
 ** module id = 1021
 ** module chunks = 1
 **/